<div fxLayoutAlign.gt-md="space-between center" fxLayout.lt-md="column">
  <h1>Liberar disciplina</h1>
  <div fxLayoutGap="10px">
    <mat-form-field appearance="outline">
      <mat-label>Período Letivo</mat-label>
      <mat-select [(value)]="anoSelecionado" (selectionChange)="getData()">
        <mat-option *ngFor="let ano of anos" [value]="ano">
          {{ ano }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Semestre</mat-label>
      <mat-select [(value)]="semestreSelecionado" (selectionChange)="getData()">
        <mat-option></mat-option>
        <mat-option value="1">1</mat-option>
        <mat-option value="2">2</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<mat-card class="info">
  <p><b>Atenção</b></p>
  <ul>
    <li>A liberação das disciplinas do calendário <b>2025</b> deverá ser realizada pelo Chefe de Departamento a partir de 01/01/2025</li>
  </ul>
</mat-card>
<br/>

<mat-form-field appearance="outline" fxFill>
  <mat-icon matPrefix>search</mat-icon>
  <mat-label>Pesquisar</mat-label>
  <input matInput type="search" (keyup)="search($event)" placeholder="" #input />
</mat-form-field>

<div class="mat-elevation-z8">
  <table mat-table [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
      <td mat-cell data-label="#" *matCellDef="let row">{{ row.id }}</td>
    </ng-container>
    <ng-container matColumnDef="nome">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Disciplina</th>
      <td mat-cell data-label="Disciplina" *matCellDef="let row">{{ row.nome }}</td>
    </ng-container>
    <ng-container matColumnDef="sigla">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Código</th>
      <td mat-cell data-label="Código" *matCellDef="let row">{{ row.sigla }}</td>
    </ng-container>
    <ng-container matColumnDef="duracao">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Duração</th>
      <td mat-cell data-label="Duração" *matCellDef="let row">{{ row.duracao }}</td>
    </ng-container>
    <ng-container matColumnDef="cargaHoraria">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Carga horária</th>
      <td mat-cell data-label="Carga horária" *matCellDef="let row">{{ row.cargaHoraria }}</td>
    </ng-container>
    <ng-container matColumnDef="docentesResponsaveis">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>CPF docentes responsáveis</th>
      <td mat-cell data-label="CPF docentes responsáveis" *matCellDef="let row">{{ row.docentesResponsaveis }}</td>
    </ng-container>
    <ng-container matColumnDef="selecionado">
      <th mat-header-cell *matHeaderCellDef>
        <span *ngIf="isChefeDepartamento()">Selecionar</span>
      </th>
      <td mat-cell data-label="Selecionar" *matCellDef="let row">
        <mat-checkbox *ngIf="isChefeDepartamento()" (change)="mudarSelecao(row)" [checked]="row.selecionado">
        </mat-checkbox>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="colunasGrid"></tr>
    <tr mat-row *matRowDef="let row; columns: colunasGrid"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="7">
        <span *ngIf="input.value">Nenhum registro encontrado para a pesquisa: "{{ input.value }}"</span>
        <span *ngIf="!input.value">Nenhum registro disponível</span>
      </td>
    </tr>
  </table>
  <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons></mat-paginator>
</div>
